import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';

export interface IFormTemplateDTO extends IBaseEntityDTO {
  name: string;
  body: string;
}

export class FormTemplateDTO extends BaseEntityDTO implements IFormTemplateDTO {
  name: string;
  body: string;

  constructor(data?: Partial<FormTemplateDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.name = data?.name ?? '';
    this.body = data?.body ?? '';
  }
}
